import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Klein Meneertje</h1>
        <p className="subtitle">De eretitel voor het kleinste meneertje van de week</p>
      </header>
      <main>
        <section className="current-klein-meneertje">
          <h2>Huidige Klein Meneertje</h2>
          <div className="profile-card">
            <div className="profile-content">
              <h3>Sandertje</h3>
              <p className="description">Dit kleine meneertje heeft een een beoordeling van 3.0 op zijn App die is gemaakt met een heel team.</p>
              <p className="date">Gekozen op: 15 oktober 2025</p>
            </div>
          </div>
        </section>
      </main>
      <footer>
        <p>© 2025 Klein Meneertje - Alle rechten voorbehouden</p>
      </footer>
    </div>
  );
}

export default App;
